module.exports = __webpack_public_path__ + "img/IE-desktop-image@1400.7659c831.png";